export default __webpack_public_path__ + "media/images/Masto-L2-Noel-96a18c945d8178871e5f27480b297e36.png";